import type { MyWork } from './my-work.types'

const STORAGE_KEY = 'adx-my-work-last-seen'

/**
 * The last My work the fleet sent this browser, so a reload shows it at once while the next read
 * runs. It is kept per person: a different sign-in on this browser never sees it. Storage that is
 * blocked or full only costs the head start.
 */
export function readLastSeenMyWork(email: string | undefined): MyWork | undefined {
  if (!email) return undefined
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null') as MyWork | null
    return stored?.me?.email === email ? stored : undefined
  } catch {
    return undefined
  }
}

export function rememberMyWork(work: MyWork): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(work))
  } catch {
    // A private window or full storage only loses the head start on the next visit.
  }
}

/** Signing out forgets it, so the next person on this browser cannot read it from storage. */
export function forgetMyWork(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Blocked storage holds nothing to forget.
  }
}
